<template>
    <div>
        
        <!-- Filter Start -->
        <custom-filter
            :getFilterOnStart="true"
            @filterChange="changeFilter"
        ></custom-filter>
        <!-- Filter End -->

        <!-- Scan & Suspicious Item and Most Suspicious Product Start -->
        <div class="row mt-4">
            <div class="col-md-8">
                <div class="innerBox">
                    <div class="col-md-4">
                        <MultiSelect 
                            v-model="filter.status"
                            :options="['by Age', 'by Usage Freq.']"
                            placeholder="Average Age"
                            class="elegant-multiselect"
                            />
                    </div>
                    <consumer-insight-bar-chart
                    ></consumer-insight-bar-chart>
                </div>
            </div>
            <div class="col-md-4">
                <div class="innerBox">
                    <div class="row">
                        <div class="col-md-6">
                        <MultiSelect 
                            v-model="filter.status"
                            :options="['by Device Used', 'by product', 'by Gender Cst', 'by Counterfeit Found']"
                            placeholder="Most Product Scan"
                            class="elegant-multiselect"
                            />
                    </div>
                    <div class="col-md-4">
                    </div>
                    <div class="col-md-2">
                        <MultiSelect 
                            v-model="filter.status"
                            :options="[]"
                            placeholder="All"
                            class="elegant-multiselect"
                            />
                    </div>
                    </div>
                    
                    <consumer-insight-pie-chart
                    ></consumer-insight-pie-chart>
                </div>
            </div>
        </div>
        <!-- Scan & Suspicious Item and Most Suspicious Product End -->

        <!-- Scan by Location Bar Chart Start -->
         <div class="row mt-4">
            <div class="col">
                <div class="innerBox">
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="elegant--sub-title">Customer Location</h5>
                        </div>
                        <div class="col-md-2">
                            <MultiSelect 
                                v-model="filter.status"
                                :options="[]"
                                placeholder="All Province"
                                class="elegant-multiselect"
                                />
                        </div>
                        <div class="col-md-2">
                            <MultiSelect 
                                v-model="filter.status"
                                :options="[]"
                                placeholder="All City"
                                class="elegant-multiselect"
                                />
                        </div>
                        <div class="col-md-2">
                            <MultiSelect 
                                v-model="filter.status"
                                :options="['by Suspicious Act']"
                                placeholder="by Scan Activities"
                                class="elegant-multiselect"
                                />
                        </div>
                    </div>
                </div>
            </div>
         </div>
        <!-- Scan by Location Bar Chart End -->
        
    </div>
</template>

<script>
    import customFilter from '@/components/filter/customFilter'
    import ConsumerInsightBarChart from './children/consumerInsightBarChart.vue';
    import ConsumerInsightPieChart from './children/consumerInsightPieChart.vue';
    // import highlightStats from './children/HighlightStats'

    

    export default {
        metaInfo : {
            title : 'Highlights'
        },
        data () {
            return {
                filter : {}
            }
        },
        components : {
            customFilter,

            ConsumerInsightBarChart,
            ConsumerInsightPieChart,
            // highlightStats,

            
        },
        mounted () {

        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) this.filter[i] = filter[i];
                // console.log(this.filter);
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }
</style>